var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid"},[_vm._l((_vm.gridLines),function(line,idx){return _c('div',{key:`line-${idx}`,staticClass:"grid__line",class:_vm.customClass || '',style:(line.style)})}),_vm._l((_vm.gridColumns),function(col,idx){return _c('div',{key:`col-${idx}`,staticClass:"grid__col",class:_vm.customClass || '',style:(col.style)})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }